import { AfterViewInit, Component, ElementRef, EventEmitter, inject, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { DxTreeViewComponent, DxTreeViewModule, DxTreeViewTypes } from 'devextreme-angular/ui/tree-view';
import * as events from 'devextreme/events';
import { navigation } from 'src/app/app-navigation';

@Component({
    selector: 'app-side-navigation-menu',
    templateUrl: './side-navigation-menu.component.html',
    styleUrls: ['./side-navigation-menu.component.scss'],
    standalone: true,
    imports: [DxTreeViewModule],
})
export class SideNavigationMenuComponent implements AfterViewInit, OnDestroy {
    protected elementRef = inject(ElementRef);
    @ViewChild(DxTreeViewComponent, { static: true })
    menu!: DxTreeViewComponent;

    @Output()
    selectedItemChanged = new EventEmitter<DxTreeViewTypes.ItemClickEvent>();

    @Output()
    openMenu = new EventEmitter<any>();

    @Input()
    get compactMode() {
        return this._compactMode;
    }

    @Input()
    set selectedItem(value: string) {
        this._selectedItem = value;
        this.setSelectedItem();
    }

    get selectedItem(): string {
        return this._selectedItem;
    }

    // eslint-disable-next-line @typescript-eslint/adjacent-overload-signatures
    set compactMode(val: boolean) {
        this._compactMode = val;

        if (!this.menu.instance) {
            return;
        }

        if (val) {
            this.menu.instance.collapseAll();
        } else {
            this.menu.instance.expandItem(this._selectedItem);
        }
    }

    private _selectedItem!: string;

    private _items!: Record<string, unknown>[];

    get items() {
        if (!this._items) {
            this._items = navigation.map((item: any) => {
                if (item.path && !/^\//.test(item.path)) {
                    item.path = `/${item.path}`;
                }
                return { ...item, expanded: !this._compactMode };
            });
        }

        return this._items;
    }

    private _compactMode = false;

    setSelectedItem() {
        if (!this.menu.instance) {
            return;
        }

        this.menu.instance.selectItem(this.selectedItem);
    }

    onItemClick(event: DxTreeViewTypes.ItemClickEvent) {
        this.selectedItemChanged.emit(event);
    }

    ngAfterViewInit() {
        this.setSelectedItem();
        events.on(this.elementRef.nativeElement, 'dxclick', (e: Event) => {
            this.openMenu.next(e);
        });
    }

    ngOnDestroy() {
        events.off(this.elementRef.nativeElement, 'dxclick');
    }
}
